
import { Button } from 'primereact/button';
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import SuccessModal from '../SuccessModal';
import { getCustomerLoyaltyPointApplyDiscount } from '../../services/LoyaltyPoint/LoyaltyPoint';
import { InputText } from 'primereact/inputtext';
import { getStoreLocalData } from '../../utils/localStorage';


const LoyaltyPointRedeemNow = () => {
     const navigate = useNavigate();
     
     const location = useLocation();
     const {  
            storeId,
            storeCustomerId,
            bookingOrderId,
            LoyaltyPoint,
            customerLoyaltyPointCheckDiscount,
            balanceAmount,
            invoiceNo,
     } = location.state || {}; // Fallback to prevent undefined errors
   
     const { storeLocalData } = getStoreLocalData();
    //  const handleBackButton = () => {
    //     navigate('/PaymentCollection', {state:{
    //       storeCustomerId: storeCustomerId,
    //       bookingOrderId: bookingOrderId,
    //     }});
    //  }

     const [verificationCode, setVerificationCode] = useState('')
     const [modalVisible, setModalVisible] = useState(false);
     const [apiResStatus, setApiResStatus] = useState(false);
     const [apiResMessage, setApiResMessage] = useState(false);

     const [isButtonPressed, setIsButtonPressed] =
    useState(false);

     const handleLoyaltyPointButton = () => {
      setIsButtonPressed(true);
      const data = {
        verificationRequested: true,
        orderAmount: balanceAmount,
        verificationCode: verificationCode,
        orderId: bookingOrderId,
        invoiceNo: invoiceNo
      }
      getCustomerLoyaltyPointApplyDiscount(storeId, storeCustomerId, data)
      .then(response => {
        if(!response.data.error) {
          const Res = response.data;
          if(Res) {
            const success = Res.status;
            if(success === 'success') {
              setModalVisible(true);
              setApiResStatus('success');
              setApiResMessage('Loyalty Point Discount Added Successfully');
            } else {
              setModalVisible(true);
              setApiResStatus('not success');
              setApiResMessage('Loyalty Point Discount Not Added Please Try Again');
            }
            setIsButtonPressed(false);
            const timer = setTimeout(() => {
              navigate("/PaymentCollection", {state: {
                bookingOrderId: bookingOrderId,
                storeCustomerId: storeCustomerId,
              }});
            }, 1500);
            return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
          } else {
            setModalVisible(true);
            setApiResStatus('not success');
            setApiResMessage('Loyalty Point Discount Not Added Please Try Again');
            setIsButtonPressed(false);
            const timer = setTimeout(() => {
              navigate("/PaymentCollection", {state: {
                bookingOrderId: bookingOrderId,
                storeCustomerId: storeCustomerId,
              }});
            }, 1500);
            return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
          }
        }
      })
    }

  return (
    <div className='flex flex-1 justify-content-center '>
      <div className='flex flex-column justify-content-center align-items-center'>
        <img
          src={'VectorsLaundryApp/DhobiCart.png'}
          style={{
            width:   200,
            
          }}
        />
        <p className='text-4xl font-medium' style={{color: '#2B70D7'}}>Thank You For Using Your {LoyaltyPoint} Loyalty Point</p>
        <p className='text-3xl font-medium'>Your Discount Amount is {storeLocalData?.currencySymbol} {customerLoyaltyPointCheckDiscount?.amount} Loyalty Point</p>
        <p className='text-2xl font-medium' style={{color: '#2B70D7'}}>Please Enter Your Verification Code Below and Redeem Your Loyalty Point On This Bill</p>
        <div className="flex-1">
                <p>Enter Verification Code</p>
                <InputText
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  className="w-full text-xl  border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  keyboardType="numeric"
                  disabled={isButtonPressed}
                />
              </div>
        {verificationCode.length === 6 && <Button
                  className="mt-3 mb-3 mx-4 border-round-xl flex-1 "
                  onClick={handleLoyaltyPointButton}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    Redeem Now
                  </p>
                </Button>}
      </div>
      <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={apiResStatus === "success" ? "success" : false}
          text={apiResMessage}
        />
    </div>
  );
}


export default LoyaltyPointRedeemNow


 
